import CheckboxInput from "Components/molecule/inputs/checkbox-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import FormContainer from "Components/atoms/containers/form-container"
import BillabilityReportRecipientFields from "./types"

interface BillabilityReportRecipientFormProps extends FormProps<BillabilityReportRecipientFields> {
    employees: SelectOption[]
}

const EMPLOYEE_KEY = "employeeId";
const WEEKLY_KEY = "weekly";
const MONTHLY_KEY = "monthly";

const BillabilityReportRecipientForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    employees,
    setFieldValue,
    edit
}: BillabilityReportRecipientFormProps) => {

    return <FormContainer
        inputs={<>
            {/* The employee is fixed once added; editing only changes which emails they get. */}
            {!edit && <SearchSelect
                name={EMPLOYEE_KEY}
                key={EMPLOYEE_KEY}
                className="col-12"
                label={"Employee*"}
                placeholder={"Search employee..."}
                value={values.employeeId}
                error={!!touched.employeeId && !!errors.employeeId}
                message={touched.employeeId ? errors.employeeId : undefined}
                options={employees}
                onChange={(option: SelectOption | null) => handleChange(EMPLOYEE_KEY)(option ? option.value : '')}
                onBlur={handleBlur(EMPLOYEE_KEY)}
                clearable
            />}

            <CheckboxInput
                name={WEEKLY_KEY}
                key={WEEKLY_KEY}
                className="col-6"
                label={"Weekly"}
                checked={values.weekly}
                onChange={(e) => setFieldValue?.(WEEKLY_KEY, e.target.checked)}
            />

            <CheckboxInput
                name={MONTHLY_KEY}
                key={MONTHLY_KEY}
                className="col-6"
                label={"Monthly"}
                checked={values.monthly}
                onChange={(e) => setFieldValue?.(MONTHLY_KEY, e.target.checked)}
            />
        </>}

        buttons={
            <PrimaryButton
                className="w-100"
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Saving...." : edit ? "Update" : "Save"}
            </PrimaryButton>
        }
    />
}

export default BillabilityReportRecipientForm
